import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-main-loader',
  templateUrl: './main-loader.component.html',
  styleUrls: ['./main-loader.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MainLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
